/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import MultiSelectSearchDropdown from '../../../Components/MultiFilterSearch/multiFilterSearch';
import { MANAGE_KPI_DASHBOARD } from '../../../Constants/strings';
import backIcon from '../../../Assets/images/svg/black_back_button.svg';
import styles from './filters.module.scss';
import {
  fetchDepartmentList,
  fetchDesignationList,
  fetchVertivalList,
  fetchPerformancePeriodList,
} from './filtersUtil';

const Filters = ({
  verticalSelected,
  setVertical,
  departmentSelected,
  setDepartment,
  designationSelected,
  setDesignation,
  performancePeriodSelected,
  setPerformancePeriod,
  isEdit,
  showImage,
}) => {
  const [verticalList, setVerticalList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [performancePeriodList, setPerformancePeriodList] = useState([]);
  const [kpiVertical, setKpiVertical] = useState([]);
  const [kpiDepartment, setKpiDepartment] = useState([]);
  const [kpiDesignation, setKpiDesignation] = useState([]);
  const [kpiPerformancePeriod, setKpiPerformancePeriod] = useState([]);

  useEffect(() => {
    fetchVertivalList().then(setVerticalList);
    fetchDepartmentList().then(setDepartmentList);
    fetchDesignationList().then(setDesignationList);
    fetchPerformancePeriodList().then(setPerformancePeriodList);
  }, []);

  useEffect(() => {
    const storedKpiVertical = localStorage.getItem('kpiVertical'); // Load data from localStorage
    const storedKpiDepartment = localStorage.getItem('kpiDepartment');
    const storedKpiDesignation = localStorage.getItem('kpiDesignation');
    const storedKpiPerformance = localStorage.getItem('kpiPerformance');
    if (storedKpiVertical) {
      const parsedKpiVertical = JSON.parse(storedKpiVertical);
      setKpiVertical(parsedKpiVertical);
    }
    if (storedKpiDepartment) {
      const parsedKpiDepartment = JSON.parse(storedKpiDepartment);
      setKpiDepartment(parsedKpiDepartment);
    }
    if (storedKpiDesignation) {
      const parsedKpiDesignation = JSON.parse(storedKpiDesignation);
      setKpiDesignation(parsedKpiDesignation);
    }
    if (storedKpiPerformance) {
      const parsedKpiPerformance = JSON.parse(storedKpiPerformance);
      setKpiPerformancePeriod(parsedKpiPerformance);
    }
  }, []);

  const navigate = useNavigate();

  let title = '';
  if (showImage) {
    title = MANAGE_KPI_DASHBOARD.SET.TITLE;
  } else if (isEdit) {
    title = MANAGE_KPI_DASHBOARD.EDIT.TITLE;
  } else {
    title = MANAGE_KPI_DASHBOARD.SET.TITLE;
  }

  return (
    <section className={styles.container}>
      <header>
        <button
          type="button"
          className={styles['back-button']}
          onClick={() => {
            navigate('/configuration/manage-kpi');
          }}
        >
          <img src={backIcon} alt="back icon" />
        </button>
        <h2 style={{ marginTop: '5px' }}>
          {title}
        </h2>
      </header>
      <div className={styles['search-container']}>
        <div className={styles['search-performance-period-container']}>
          <MultiSelectSearchDropdown
            mode="listbox"
            multiSelectCss={styles['search-performance-period']}
            options={performancePeriodList}
            value={kpiPerformancePeriod}
            onChange={(event) => setPerformancePeriod(event.target.value)}
            placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.PERFORMANCE}
            autoFocus={true}
            size="small"
            label=""
            SearchPlaceHolder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.PERFORMANCE}
            disabled={true}
            showFilterIcon={false}
          />
        </div>
        <div className={styles['search-vertical-container']}>
          <MultiSelectSearchDropdown
            mode="listbox"
            multiSelectCss={styles['search-vertical']}
            options={verticalList}
            value={isEdit ? kpiVertical : verticalSelected}
            onChange={(event) => setVertical(event.target.value)}
            placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.VERTICAL}
            autoFocus={true}
            size="small"
            label=""
            SearchPlaceHolder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.VERTICAL}
            disabled={isEdit}
            showFilterIcon={false}
          />
        </div>
        <div className={styles['search-department-container']}>
          <MultiSelectSearchDropdown
            mode="listbox"
            multiSelectCss={styles['search-department']}
            options={departmentList}
            value={isEdit ? kpiDepartment : departmentSelected}
            onChange={(event) => setDepartment(event.target.value)}
            placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DEPARTMENT}
            autoFocus={true}
            size="small"
            label=""
            SearchPlaceHolder={
              MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DEPARTMENT
            }
            disabled={isEdit}
            showFilterIcon={false}
          />
        </div>
        <div className={styles['search-designation-container']}>
          <MultiSelectSearchDropdown
            mode="listbox"
            multiSelectCss={styles['search-designation']}
            options={designationList}
            value={isEdit ? kpiDesignation : designationSelected}
            onChange={(event) => setDesignation(event.target.value)}
            placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DESIGNATION}
            autoFocus={true}
            size="small"
            label=""
            SearchPlaceHolder={
              MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DESIGNATION
            }
            disabled={isEdit}
            showFilterIcon={false}
          />
        </div>
      </div>
    </section>
  );
};

Filters.propTypes = {
  verticalSelected: PropTypes.array,
  setVertical: PropTypes.func,
  departmentSelected: PropTypes.array,
  setDepartment: PropTypes.func,
  designationSelected: PropTypes.array,
  setDesignation: PropTypes.func,
  performancePeriodSelected: PropTypes.array,
  setPerformancePeriod: PropTypes.func,
  isEdit: PropTypes.bool,
  showImage: PropTypes.bool,
};

export default Filters;
